import { render, staticRenderFns } from "./WorkEditor.vue?vue&type=template&id=5ce7af80&scoped=true&"
import script from "./WorkEditor.vue?vue&type=script&lang=js&"
export * from "./WorkEditor.vue?vue&type=script&lang=js&"
import style0 from "./WorkEditor.vue?vue&type=style&index=0&lang=css&"
import style1 from "./WorkEditor.vue?vue&type=style&index=1&id=5ce7af80&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ce7af80",
  null
  
)

component.options.__file = "WorkEditor.vue"
export default component.exports